import { z } from 'zod';
import { StoreProductStatus } from '../../enums/crew.js';
import { enumToZodLiteralUnion, helperSchema } from '../../zodExtensions.js';
// the main source of truth for variants on platform
export const variant = z.object({
    idFromPlatform: z.string(),
    price: z.coerce.number(),
    quantity: z.number(),
    grams: z.number(),
    // this is the title of the product technically / usually displayed with options
    title: z.string(),
    options: z.array(z.object({ name: z.string(), value: z.string() })),
    // this is the title of the variant, which is a combination of the product title and the options
    titleWithOptions: z.string(),
    optionsValueString: z.string(),
    sku: z.string().nullish(),
    imgUrl: z.string().nullish(),
    barcode: z.string().nullish(),
});
export const storeProductVariant = variant.extend({
    id: z.number(),
});
// * variant exchange
export const storeProduct = z.object({
    id: z.number(),
    title: z.string(),
    idFromPlatform: z.string(),
    imgUrl: z.string().nullable(),
    vendor: z.string().nullish(),
    productType: z.string().nullish(),
    tags: z.array(z.string()).nullish(),
    variants: z.array(storeProductVariant),
});
export const registrationProductVariant = storeProductVariant;
export const registrationProduct = storeProduct;
export const productType = z.object({
    id: z.number(),
    name: z.string(),
});
export const productTag = z.object({
    id: z.number(),
    name: z.string(),
});
export const productCollection = z.object({
    id: z.number(),
    name: z.string(),
});
export const storeProductGroup = z.object({
    id: z.number(),
    name: helperSchema.nonEmptyString,
    types: z.array(productType),
    tags: z.array(productTag),
    collections: z.array(productCollection),
    lastUpdatedOn: helperSchema.optionalizedString,
    createdOn: z.string().optional(),
});
export const storeProductListItem = storeProduct
    .pick({
    id: true,
    title: true,
    idFromPlatform: true,
    imgUrl: true,
    productType: true,
})
    .extend({
    createdOn: z.string(),
    status: z.string().nullable(),
    isOffPlatform: z.boolean(),
});
export const storeProductList = z.array(storeProductListItem);
export const storeProductDetail = storeProduct.extend({
    createdOn: z.string(),
    handle: z.string().nullable(),
    status: z.string().nullable(),
    isOffPlatform: z.boolean(),
    /** Null for off-platform products, which have no platform admin to link to. */
    platformAdminUrl: z.string().nullable(),
});
export const storeProductGroupMembership = z.array(storeProductGroup.pick({ id: true, name: true }));
export const storeProductRegistrationChannels = z.array(z.object({ id: z.number(), name: z.string() }));
export const storeProductUpdate = z.object({
    title: helperSchema.nonEmptyString,
    status: enumToZodLiteralUnion(StoreProductStatus),
    productType: helperSchema.nonEmptyString.nullable(),
    vendor: helperSchema.nonEmptyString.nullable(),
    tags: z.array(helperSchema.nonEmptyString),
});
export const storeProductMinimum = storeProduct
    .pick({
    id: true,
    title: true,
    idFromPlatform: true,
    imgUrl: true,
})
    .merge(z.object({
    variants: z.array(storeProductVariant.pick({
        id: true,
        title: true,
        idFromPlatform: true,
        imgUrl: true,
        sku: true,
    })),
}));
export const storeProductGroupCreate = storeProductGroup.omit({ id: true });
export const storeProductImport = z.object({
    csv: z.string().min(1),
    shouldDedupeBySku: z.boolean(),
});
export const storeProductImportAccepted = z.object({ rowCount: z.number() });
//# sourceMappingURL=storeProduct.js.map